const getErrorMessage = (res, fallback) => {
  const data = res?.data;

  if (!data) return fallback;
  if (typeof data === "string") return data;
  if (data.detail) return data.detail;

  const fieldErrors = Object.values(data)
    .flat()
    .filter((msg) => typeof msg === "string");

  if (fieldErrors.length) return fieldErrors.join(" ");

  return fallback;
};

export default getErrorMessage;
